/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { IsProductsSerializableFromWarehouseStockActualByAgreementResponse } from '../../models/is-products-serializable-from-warehouse-stock-actual-by-agreement-response';

export interface WarehouseControllerProductsSerializableFromWarehouseStockActualByAgreement$Params {
  warehouse_id: number;
  product_id?: number;
  product_purpose?: number;
  related_agreement_id?: number;
}

export function warehouseControllerProductsSerializableFromWarehouseStockActualByAgreement(http: HttpClient, rootUrl: string, params: WarehouseControllerProductsSerializableFromWarehouseStockActualByAgreement$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: IsProductsSerializableFromWarehouseStockActualByAgreementResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, warehouseControllerProductsSerializableFromWarehouseStockActualByAgreement.PATH, 'get');
  if (params) {
    rb.query('warehouse_id', params.warehouse_id, {});
    rb.query('product_id', params.product_id, {});
    rb.query('product_purpose', params.product_purpose, {});
    rb.query('related_agreement_id', params.related_agreement_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: IsProductsSerializableFromWarehouseStockActualByAgreementResponse;
      }>;
    })
  );
}

warehouseControllerProductsSerializableFromWarehouseStockActualByAgreement.PATH = '/warehouse/products-serializable-from-warehouse_stock_actual_by_agreement';
